import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';
import { browserHistory } from 'react-router';

import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import { findByUID, findById } from '../../../core/utils';
import {
  fetchCatchNews,
  fetchCatchPartnerSpecials,
  fetchCatchAnnouncementsConfig,
  fetchBrandsDetailsConfig,
  fetchBrandsContactsConfig
} from './api';
// ------------------------------------
// Constants
// ------------------------------------
export const BRANDS_DETAILS_FETCH_REQUEST = 'BRANDS_DETAILS_FETCH_REQUEST';
export const BRANDS_DETAILS_FETCH_SUCCESS = 'BRANDS_DETAILS_FETCH_SUCCESS';
export const BRANDS_DETAILS_FETCH_FAILURE= 'BRANDS_DETAILS_FETCH_FAILURE';

export const BRANDS_CONTACT_FETCH_REQUEST = 'BRANDS_CONTACT_FETCH_REQUEST';
export const BRANDS_CONTACT_FETCH_SUCCESS = 'BRANDS_CONTACT_FETCH_SUCCESS';
export const BRANDS_CONTACT_FETCH_FAILURE= 'BRANDS_CONTACT_FETCH_FAILURE';

export const CATCH_NEWS_FETCH_FAILURE = 'CATCH_NEWS_FETCH_FAILURE';
export const CATCH_NEWS_FETCH_REQUEST = 'CATCH_NEWS_FETCH_REQUEST';
export const CATCH_NEWS_FETCH_SUCCESS = 'CATCH_NEWS_FETCH_SUCCESS';

export const CATCH_PARTNER_SPECIAL_FETCH_FAILURE = 'CATCH_PARTNER_SPECIAL_FETCH_FAILURE';
export const CATCH_PARTNER_SPECIAL_FETCH_REQUEST = 'CATCH_PARTNER_SPECIAL_FETCH_REQUEST';
export const CATCH_PARTNER_SPECIAL_FETCH_SUCCESS = 'CATCH_PARTNER_SPECIAL_FETCH_SUCCESS';

export const CATCH_ANNOUNCEMENTS_CONFIG_FETCH_FAILURE = 'CATCH_ANNOUNCEMENTS_CONFIG_FETCH_FAILURE';
export const CATCH_ANNOUNCEMENTS_CONFIG_FETCH_REQUEST = 'CATCH_ANNOUNCEMENTS_CONFIG_FETCH_REQUEST';
export const CATCH_ANNOUNCEMENTS_CONFIG_FETCH_SUCCESS = 'CATCH_ANNOUNCEMENTS_CONFIG_FETCH_SUCCESS';


// ------------------------------------
// Actions
// ------------------------------------


export function FetchBrandsRequest() {
  return {
    type: BRANDS_DETAILS_FETCH_REQUEST,
    payload: null,
  };
}

export function FetchBrandsSuccess(json) {
  return {
    type: BRANDS_DETAILS_FETCH_SUCCESS,
    payload: json,
  };
}

export function fetchBrandsFailure(json) {
  return {
    type: BRANDS_DETAILS_FETCH_FAILURE,
    payload : json,
  };
}

export function FetchBrandsContactRequest() {
  return {
    type: BRANDS_CONTACT_FETCH_REQUEST,
    payload: null,
  };
}

export function FetchBrandsContactSuccess(json) {
  return {
    type: BRANDS_CONTACT_FETCH_SUCCESS,
    payload: json,
  };
}

export function fetchBrandsContactFailure(json) {
  return {
    type: BRANDS_CONTACT_FETCH_FAILURE,
    payload : json,
  };
}

export function catchNewsFetchRequest() {
  return {
    type: CATCH_NEWS_FETCH_REQUEST,
    payload: null,
  };
}
export function catchNewsFetchSuccess(json) {
  return {
    type: CATCH_NEWS_FETCH_SUCCESS,
    payload: json,
  };
}
export function catchNewsFetchFailure(json) {
  return {
    type: CATCH_NEWS_FETCH_FAILURE,
    payload: json,
  };
}


export function catchPartnerSpecialFetchRequest() {
  return {
    type: CATCH_PARTNER_SPECIAL_FETCH_REQUEST,
    payload: null,
  };
}
export function catchPartnerSpecialFetchSuccess(json) {
  return {
    type: CATCH_PARTNER_SPECIAL_FETCH_SUCCESS,
    payload: json,
  };
}
export function catchPartnerSpecialFetchFailure(json) {
  return {
    type: CATCH_PARTNER_SPECIAL_FETCH_FAILURE,
    payload: json,
  };
}

export function catchAnnouncementsConfigFetchRequest() {
  return {
    type: CATCH_ANNOUNCEMENTS_CONFIG_FETCH_REQUEST,
    payload: null,
  };
}
export function catchAnnouncementsConfigFetchSuccess(json) {
  return {
    type: CATCH_ANNOUNCEMENTS_CONFIG_FETCH_SUCCESS,
    payload: json,
  };
}
export function catchAnnouncementsConfigFetchFailure(json) {
  return {
    type: CATCH_ANNOUNCEMENTS_CONFIG_FETCH_FAILURE,
    payload: json,
  };
}

export function requestBrands(){
  return dispatch => {
    dispatch(FetchBrandsRequest());
    return fetchBrandsDetailsConfig()
    .then(checkHttpStatus)
    .then(parseJSON)
    .then(response => {
      dispatch(FetchBrandsSuccess(response));
    })
    .catch(error => {
      if (error && typeof error.response !=='undefined'){
        const status = error.response.status;
        if (status === 400){
          error.response.json().then(detail => {
            console.log('400',detail);
            dispatch(fetchBrandsFailure(detail));
          });
        } else if (status >= 401 && status <= 403){
          return error.response.json().then(detail => {
            dispatch(authLoginUserFailure(status, detail));
            dispatch(push('/login'));
          });
        } else if (status >= 404) {
          console.log('Yikes problem with server. ', status);
          const notificationOpts = {
            title: 'Yikes!',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestBrands()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
      } else {
        const notificationOpts = {
          title: 'Yikes!',
          message: 'We can not connect to the server. Try again in a bit.',
          autoDismiss: 0,
          action: {
            label: 'Retry',
            callback: () => dispatch(requestBrands()),
          },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(fetchBrandsFailure());
    });
  };
}

export function getBrandContacts(){
  return dispatch => {
    dispatch(FetchBrandsContactRequest());
    return fetchBrandsContactsConfig()
    .then(checkHttpStatus)
    .then(parseJSON)
    .then(response => {
      dispatch(FetchBrandsContactSuccess(response));
    })
    .catch(error => {
      if (error && typeof error.response !=='undefined'){
        const status = error.response.status;
        if (status === 400){
          error.response.json().then(detail => {
            console.log('400',detail);
            dispatch(fetchBrandsContactFailure(detail));
          });
        } else if (status >= 401 && status <= 403){
          return error.response.json().then(detail => {
            dispatch(authLoginUserFailure(status, detail));
            dispatch(push('/login'));
          });
        } else if (status >= 404) {
          console.log('Yikes problem with server. ', status);
          const notificationOpts = {
            title: 'Yikes!',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(getBrandContacts()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
      } else {
        const notificationOpts = {
          title: 'Yikes!',
          message: 'We can not connect to the server. Try again in a bit.',
          autoDismiss: 0,
          action: {
            label: 'Retry',
            callback: () => dispatch(getBrandContacts()),
          },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(fetchBrandsContactFailure());
    });
  };
}

export function requestCatchNews() {
  return dispatch => {
    dispatch(catchNewsFetchRequest());
    return fetchCatchNews()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(catchNewsFetchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
              dispatch(catchNewsFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestCatchNews()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestCatchNews()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(catchNewsFetchFailure());
      });
  };
}

export function requestCatchPartnerSpecials() {
  return dispatch => {
    dispatch(catchPartnerSpecialFetchRequest());
    return fetchCatchPartnerSpecials()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(catchPartnerSpecialFetchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
              dispatch(catchPartnerSpecialFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestCatchPartnerSpecials()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestCatchPartnerSpecials()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(catchPartnerSpecialFetchFailure());
      });
  };
}

export function requestCatchAnnouncementsConfig() {
  return dispatch => {
    dispatch(catchAnnouncementsConfigFetchRequest());
    return fetchCatchAnnouncementsConfig()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(catchAnnouncementsConfigFetchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
              dispatch(catchAnnouncementsConfigFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestCatchAnnouncementsConfig()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestCatchAnnouncementsConfig()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(catchAnnouncementsConfigFetchFailure());
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {

[BRANDS_DETAILS_FETCH_REQUEST] : (state, action) => {
  return update(state,{
    $merge: {
      needFetch: false,
      isFetching: true,
    },
  });
},

[BRANDS_DETAILS_FETCH_SUCCESS] : (state, action) => {
  return update(state,{
    $merge: {
      needFetch:false,
      brands: action.payload.results,
    },
  });
},

[BRANDS_DETAILS_FETCH_FAILURE] : (state, action) => {
  return update(state,{
    $merge: {
      needFetch: false,
      isFetching: true,
    },
  });
},

[BRANDS_CONTACT_FETCH_REQUEST] : (state, action) => {
  return update(state,{
    $merge: {
      needFetch: false,
      isFetching: true,
    },
  });
},

[BRANDS_CONTACT_FETCH_SUCCESS] : (state, action) => {
  return update(state,{
    $merge: {
      needFetch:false,
      brandsContacts: action.payload.results,
    },
  });
},

[BRANDS_CONTACT_FETCH_FAILURE] : (state, action) => {
  return update(state,{
    $merge: {
      needFetch: false,
      isFetching: true,
    },
  });
},

[CATCH_NEWS_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      $merge: {
        needFetch: false,
        isFetching: true,
      },
    });
  },
  [CATCH_NEWS_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      $merge: {
        isFetching: false,
        catchNews: action.payload.results,
      },
    });
  },

  [CATCH_PARTNER_SPECIAL_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      $merge: {
        needFetch: false,
        isFetching: true,
      },
    });
  },
  [CATCH_PARTNER_SPECIAL_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      $merge: {
        isFetching: false,
        catchPartnerSpecials: action.payload.results,
      },
    });
  },

  [CATCH_ANNOUNCEMENTS_CONFIG_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      $merge: {
        needFetch: false,
        isFetching: true,
      },
    });
  },
  [CATCH_ANNOUNCEMENTS_CONFIG_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      $merge: {
        isFetching: false,
        catchAnnouncementsConfig: action.payload.results,
      },
    });
  },
};



// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  catchNews: [],
  catchPartnerSpecials: [],
  catchAnnouncementsConfig: [],
  isFetching: false,
  needFetch: true
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}


// WEBPACK FOOTER //
// src/routes/home/modules/travelmanagerhome.js